import { render, staticRenderFns } from "./arrival.vue?vue&type=template&id=3b64ad20&scoped=true&"
import script from "./arrival.vue?vue&type=script&lang=js&"
export * from "./arrival.vue?vue&type=script&lang=js&"
import style0 from "./arrival.vue?vue&type=style&index=0&id=3b64ad20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b64ad20",
  null
  
)

export default component.exports